import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorWrapper = styled.div.withConfig({
  displayName: "ErrorState__ErrorWrapper",
  componentId: "sc-1otra5w-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;flex-direction:column;"]);
const ErrorState = () => /*#__PURE__*/_jsxs(ErrorWrapper, {
  children: [/*#__PURE__*/_jsx("h5", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-ui.asyncError.body"
    })
  }), /*#__PURE__*/_jsx("div", {
    className: "m-top-3",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-ui.asyncError.noRetry"
    })
  })]
});
ErrorState.displayName = 'ErrorState';
export default ErrorState;